
import { useSelector } from "react-redux";

import AccountLinksTab from "../../../components/account/AccountLinksTab";
import Header from "../../../components/homepage/Header";
import Navigation from "../../../components/homepage/Navigation/Navigation";
import FooterCard from "../../../components/homepage/FooterCard";
import { Toaster } from "react-hot-toast";
import { selectUserDetails } from "../../../redux/userSlice";
import whatsApppIcon from "../../../assets/images/whatsApppIcon.svg";

const AccountMenu = ({ children }) => {
  const userDetail = useSelector(selectUserDetails);

  return (
    <div>
      <Header />
      <Navigation />
      <section className="frame-parentAccount">
        <div className="frame-groupAccount">
          <div className="account-parentAccount">
            <h3 className="accountAccount">Account</h3>
            <div className="steven-robertAccount">{userDetail?.username}</div>
          </div>
          <div className="frame-childAccount" />
        </div>
        <div className="frame-containerAccount">
          <AccountLinksTab />
          {children}
        </div>
      </section>

      <div
        style={{
          position: "fixed",
          bottom: 20,
          right: 20,
          cursor: "pointer",
          zIndex: 2000,
        }}
        onClick={() =>
          window.open(
            "https://api.whatsapp.com/send?phone=60193278400",
            "_blank"
          )
        }
      >
        <img
          style={{ width: "70px" }}
          src={whatsApppIcon}
          alt="whats-app-icon"
        />
      </div>
      <FooterCard />
      <Toaster position="top-right" />
    </div>
  );
};

export default AccountMenu;
